import { UnavailableTag } from '../primitives'
import ProductItemDetails from '../ProductItemDetails'
import { ProductQtyChanger } from '~/design-system/components'
import type { Product } from '~/type/Cart'

export type ProductItemProps = {
  item: Product
  isControled?: boolean
}
export default function ProductItem({ item, isControled }: ProductItemProps) {
  const isUnavailable = item.isAvailable === false || item.price === null

  return (
    <li
      className="w-full flex items-start justify-between pt-2 mb-2 pb-4 border-b border-dashed text-sm gap-2 relative"
      data-id={item.id}
    >
      <ProductItemDetails isControled={isControled} item={item} />
      {isControled && !isUnavailable && (
        <ProductQtyChanger
          className="w-[110px] min-w-[110px] self-center"
          itemId={item.id}
          product={item}
          quantity={item.quantity}
        />
      )}
      {isUnavailable && <UnavailableTag description="Indisponível" item={item} />}
    </li>
  )
}
